export const EASE = [0.22, 1, 0.36, 1];
export const VIEWPORT = { once: true, amount: 0.15 };

export const scrollToHash = (href) => {
  if (href === "#top") {
    if (window.__lenis) window.__lenis.scrollTo(0);
    else window.scrollTo({ top: 0, behavior: "smooth" });
    return;
  }
  if (window.__lenis) window.__lenis.scrollTo(href, { offset: -72 });
  else document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
};
